import client from '../httpClient';

const areaWishCityCountUpdateApi = (params) => {
  return client.put('/allocation-settings/area-wish-city-count', params);
};

export default areaWishCityCountUpdateApi;
